module.exports = __webpack_public_path__ + "img/Trophy Cup Table40.80b1bb7a.jpg";